import * as React from 'react';
import {connect} from "react-redux";
import authState from '../../../ReduxRequests/State/authState';
import InvitationTableViewHeader from './InvitationTableViewHeader';
import InvitationTableViewCell from './InvitationTableViewCell';
import {CONTACT_TAB, CONTACT_ACTION, SUBAGENTS_SORT_BY, CONTACT_RELEVANT_DATE, roleOptions, USERS_SORT_BY} from '../../../Config/appConfig';
import {Auth, CompanyHistory, CompanyInfo, Option, User, UserInfo} from '../../../Config/dataModel';
import util from '../../../Util/util';
import _ from 'lodash';

interface InvitationTableViewProps {
    currentTab: string,
    subscribedCompanies?: CompanyHistory[],
    users: User[],
    clickAction?: (user: string, action: string, userId: string, role?: Option) => void,
    auth?: () => Auth
}

interface InvitationTableViewState {
    subscribedCompanies: CompanyInfo[],
    users: UserInfo[],
    sortBy: string,
    asc: boolean
}

class InvitationTableView extends React.Component <InvitationTableViewProps, InvitationTableViewState> {
    public constructor(props: InvitationTableViewProps) {
        super(props);
        this.state = {
            subscribedCompanies: [],
            users: [],
            sortBy: '',
            asc: true
        };
    }

    public componentWillMount() {
        this.props.currentTab === CONTACT_TAB.COMPANY ? this.getCompanies() : this.getUsers();
    }

    public componentWillReceiveProps(nextProps: InvitationTableViewProps) {
        if (this.props.currentTab === CONTACT_TAB.COMPANY && nextProps.subscribedCompanies && !this.state.subscribedCompanies.length) {
            this.getCompanies();
        }
        else if ((this.props.currentTab === CONTACT_TAB.NORMAL_USER || this.props.currentTab === CONTACT_TAB.API_USER) && nextProps.users && !this.state.users.length) {
            this.getUsers();
        }
    }

    public getCompanies() {
        let subscribedCompanies = [];
        for (let i = 0; i < this.props.subscribedCompanies.length; i++) {
            const company = this.props.subscribedCompanies[i];
            const isRegistered = company.writeAccess && company.readAccess;
            const lastActiveDate = util.getFormattedDate(isRegistered ? company.createTime : company.destroyTime);
            subscribedCompanies.push({
                companyName: company.displayName,
                lastActive: isRegistered ? CONTACT_RELEVANT_DATE.INVITED : CONTACT_RELEVANT_DATE.DEACTIVATED,
                lastActiveDate,
                actions: isRegistered ? [CONTACT_ACTION.DEACTIVATE] : [CONTACT_ACTION.RECOVER],
                userId: company.shortId
            });
            this.setState({
                subscribedCompanies
            });
        }
    }

    public getUsers() {
        let users = [];
        for (let i = 0; i < this.props.users.length; i++) {
            const user = this.props.users[i];
            const isRegistered = user.enabled;
            const active = user.lastActiveTime;
            const lastActiveDate = isRegistered ?
                (active ? util.getFormattedDatetime(user.lastActiveTime) : util.getFormattedDate(user.createTime)) :
                util.getFormattedDate(user.destroyTime);
            let actions = [];
            let lastActive = CONTACT_RELEVANT_DATE.LAST_LOGGED_IN;
            if (user.email !== this.props.auth().user.email) {
                if (user.locked) {
                    lastActive = CONTACT_RELEVANT_DATE.LOCKED;
                }
                if (active) {
                    if (isRegistered) {
                        actions = [CONTACT_ACTION.DEACTIVATE];
                    }
                    else {
                        actions = [CONTACT_ACTION.RECOVER];
                        lastActive = CONTACT_RELEVANT_DATE.DEACTIVATED;
                    }
                }
                else {
                    actions = [CONTACT_ACTION.RESEND_INVITATION, CONTACT_ACTION.RECALL_INVITATION];
                    lastActive = CONTACT_RELEVANT_DATE.INVITED;
                }
            }
            const email = user.email;
            users.push({
                email,
                username: `${user.firstName} ${user.lastName}`,
                lastActive,
                lastActiveDate,
                actions,
                userId: email,
                role: {
                    disabled: email === this.props.auth().user.email || !user.enabled,
                    value: user.admin ? roleOptions[1] : roleOptions[0]
                }
            });
        }

        let user = users.slice(0, 1);
        let otherUsers = users.slice(1);
        const sortedUsers = _.orderBy(otherUsers, 'lastActive.status.value', 'asc');
        this.setState({
            users: user.concat(sortedUsers)
        });
    }

    public clickSort(sortBy: string) {
        const asc = this.state.sortBy === sortBy ? !this.state.asc : true;
        let list;
        if (this.props.currentTab === CONTACT_TAB.COMPANY) {
            list = {subscribedCompanies: _.orderBy(this.state.subscribedCompanies, sortBy === SUBAGENTS_SORT_BY.COMPANY ? (subscribedCompany => subscribedCompany[sortBy].toLowerCase()) : sortBy, asc ? 'asc' : 'desc')};
        }
        else {
            list = {users: _.orderBy(this.state.users, sortBy === USERS_SORT_BY.NAME ? (user => user[sortBy].toLowerCase()) : sortBy, asc ? 'asc' : 'desc')};
        }
        this.setState({
            ...list,
            ...{
                sortBy,
                asc
            }
        });
    }

    public getInvitationTableView() {
        const list = this.props.currentTab === CONTACT_TAB.COMPANY ? this.state.subscribedCompanies : this.state.users;
        let cells = [];
        for (let i = 0; i < list.length; i++) {
            cells.push(this.getInvitationTableViewCell(i, list[i]));
        }
        return cells;
    }

    public getInvitationTableViewCell(idx: number, data: any) {
        return (
            <InvitationTableViewCell
                key={idx}
                currentTab={this.props.currentTab}
                data={data}
                clickAction={(user, action, userId, role) => this.props.clickAction(user, action, userId, role)}/>);
    }

    public render() {
        return (
            <div className={`invitationTableView${this.props.clickAction ? "" : " invitationTableViewWithoutAction"}`}>
                <InvitationTableViewHeader currentTab={this.props.currentTab} sortBy={this.state.sortBy} clickSort={(sortBy) => this.clickSort(sortBy)}/>
                {this.getInvitationTableView()}
            </div>
        );
    }
}

export default connect<any, any, InvitationTableViewProps>(authState, null)(InvitationTableView);



// WEBPACK FOOTER //
// ./src/Components/Contact/Invitation/InvitationTableView.tsx